<div class="igazolas">

  <ion-card>
    <ion-card-header>
      <ion-card-title>Hiányzás igazolása – keret és engedélyek</ion-card-title>
      <ion-card-subtitle>
        A gondviselő tanévenként ennyi napot igazolhat önállóan. Minden igazolt nap
        beleszámít a keretbe; ha elfogyott, a szülői igazolás <b>igazgatói engedélyre vár</b>,
        és csak jóváhagyás után kerül rá az igazolás a hiányzott órákra.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-note color="warning" *ngIf="!jogosult" style="display:block;margin-bottom:10px">
        Ez a menüpont csak admin jogosultsággal használható.
      </ion-note>

      <div class="sor">
        <ion-input label="Igazolható napok száma / tanév" label-placement="stacked" type="number"
                   [(ngModel)]="keretNap"></ion-input>
        <ion-button size="small" (click)="keretMentesInditas()" [disabled]="keretMentes || !jogosult">
          <ion-icon slot="start" name="save-outline"></ion-icon>Keret mentése
        </ion-button>
      </div>
      <ion-item lines="none">
        <ion-checkbox [(ngModel)]="szuloiElbiralas" (ionChange)="elbiralasMentes()" [disabled]="!jogosult" labelPlacement="end">
          A szülői igazolást is az osztályfőnök bírálja el
        </ion-checkbox>
      </ion-item>
      <ion-note color="medium">
        Bekapcsolva a gondviselői igazolás sem lesz azonnal érvényes: az osztályfőnök elfogadása után kerül
        az órákra (a keretből ilyenkor is fogy). A feltöltött orvosi és hivatalos igazolást mindig el kell bírálni.
      </ion-note>
    </ion-card-content>
  </ion-card>

  <!-- Elbírálásra váró kérések -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Elbírálásra váró kérések ({{ kerelmek.length }})</ion-card-title>
      <ion-card-subtitle>
        A kereten felüli szülői igazolások, és a szülők által mellékelt orvosi / hivatalos
        igazolások (ezeket elsősorban az osztályfőnök bírálja el; a keretet nem terhelik).
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div *ngIf="betoltes" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <div class="ures" *ngIf="!betoltes && !kerelmek.length">
        Nincs elbírálásra váró kérés.
      </div>

      <div class="kerelem" *ngFor="let k of kerelmek">
        <div class="fej">
          <b>{{ k.tanulo_nev || k.oktazon }}</b>
          <ion-badge color="light" *ngIf="k.osztaly_nev">{{ k.osztaly_nev }}</ion-badge>
          <ion-badge color="tertiary" *ngIf="k.statusz === 'elbiralasra_var'">{{ k.tipus_nev || 'Dokumentumos igazolás' }}</ion-badge>
          <span class="datum">{{ k.datum }}</span>
          <span class="muted" *ngIf="k.igenylo">kérte: {{ k.igenylo }}</span>
        </div>
        <div class="indok" *ngIf="k.indoklas"><b>Szülői indoklás:</b> {{ k.indoklas }}</div>
        <div class="dontes">
          <ion-input label="Döntés indoka (elutasításnál kötelező)" label-placement="stacked"
                     [(ngModel)]="indokok[k.id]" placeholder="A szülő is látni fogja"></ion-input>
          <ion-button size="small" color="success" (click)="dontes(k, 'jovahagy')" [disabled]="!jogosult">
            <ion-icon slot="start" name="checkmark-outline"></ion-icon>Engedélyezés
          </ion-button>
          <ion-button size="small" color="danger" fill="outline" (click)="dontes(k, 'elutasit')"
                      [disabled]="!jogosult">
            <ion-icon slot="start" name="close-outline"></ion-icon>Elutasítás
          </ion-button>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Elbírált kérések -->
  <ion-card *ngIf="elbiraltak.length">
    <ion-card-header>
      <ion-card-title>Korábbi döntések</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="elbiralt" *ngFor="let e of elbiraltak">
        <b>{{ e.tanulo_nev || e.oktazon }}</b>
        <span class="datum">{{ e.datum }}</span>
        <ion-badge [color]="e.statusz === 'igazolt' ? 'success' : 'danger'">
          {{ e.statusz === 'igazolt' ? 'Engedélyezve' : 'Elutasítva' }}
        </ion-badge>
        <span class="muted" *ngIf="e.elbiralo">{{ e.elbiralo }}</span>
        <span class="indok" *ngIf="e.elbiralas_indok">{{ e.elbiralas_indok }}</span>
      </div>
    </ion-card-content>
  </ion-card>
</div>
